module.exports = {
  base_url:
    process.env.base_url || "https://to.athenaanalytics.io/api/",
  api_base_url:
    process.env.api_base_url || "https://to.athenaanalytics.io/api/",
  open_ai_api_key:
    process.env.open_ai_api_key ||
    "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",
};
